import {
  AbsoluteCenter,
  Box,
  chakra,
  Flex,
  Image,
  shouldForwardProp,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../constant";
import i18next from "i18next";
import { useEffect, useMemo, useState } from "react";
import { isValidMotionProp, motion } from "framer-motion";
import { Helmet } from "react-helmet";

import "./styles.css";
import dayjs from "dayjs";
import { getBetRecord } from "../../api/getApi";
import { Link, useSearchParams } from "react-router-dom";
import BetRecordDetail from "./BetRecordDetail";
import NotFound from "../ProgressBlock/NotFound";
import { Splide, SplideSlide } from "@splidejs/react-splide";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const BetRecordButton = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openBetRecordDetail, setOpenBetRecordDetail] = useState(false);

  const [selectedGame, setSelectedGame] = useState("ALL");
  const [betRecords, setBetRecords] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [searchParams, setSearchParams] = useSearchParams();

  const game = searchParams.get("game") || "";

  const handleClick = () => {
    setOpenModal(true);
  };

  const fontStyle = useMemo(() => {
    return {
      className: "empire_font",
      fontSize: {
        base: "40px",
      },
      color: "#FFC6E5",
    };
  }, []);

  const gameOptions = useMemo(() => {
    return Object.keys(betRecords).length > 0
      ? [
          ...Object.keys(betRecords).filter(
            (key) => betRecords[key].totalBet !== 0 || betRecords[key].totalWinOrLose !== 0
          ),
        ]
      : [];
  }, [betRecords]);

  useEffect(() => {
    const fetchBetRecords = async () => {
      setIsLoading(true);
      try {
        // 計算時間範圍：現在到15分鐘前
        const endTime = dayjs();
        const startTime = endTime.subtract(15, "minute");

        const result = await getBetRecord({
          params: {
            str_date: startTime.toDate(),
            end_date: endTime.toDate(),
          },
        });

        if (result && result.data) {
          setBetRecords(result.data);
        }
      } catch (error) {
        console.error("無法獲取投注記錄:", error);
      } finally {
        setIsLoading(false);
      }
    };
    if (openModal) {
      fetchBetRecords();
    }
  }, [openModal]);

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.cdnfonts.com/css/a-absolute-empire"
          rel="stylesheet"
        />
      </Helmet>
      <Box
        onClick={handleClick}
        position="relative"
        cursor={"pointer"}
        display="flex"
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Image
          src={`${COMMON_WEB_PATH}/theOne/berRecord/bet_record_button${
            i18next.language == "tw" ? "" : `_${i18next.language}`
          }.png`}
          height={{
            xl: "70px",
          }}
          //minW="90px"
          minW={"90px"}
          maxW="100px"
        />
      </Box>
      {openModal && (
        <Flex
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          bg="rgba(0, 0, 0, 0.8)"
          zIndex="9999"
          //   backdropFilter="blur(2px)"
          justifyContent="center"
          alignItems="center"
          flexDir="column"
        >
          {gameOptions?.length > 0 && (
            <ChakraBox
              as={Flex}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.3 }}
              minW="700px"
              maxW="800px"
              h="110px"
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              position={"relative"}
              px="50px"
            >
              <Box
                bgImage={`url('${COMMON_WEB_PATH}/theOne/berRecord/bet_record_line.png')`}
                bgPosition="center"
                bgRepeat="no-repeat"
                bgSize="100% 100%"
                position={"absolute"}
                bottom="0"
                left="0"
                w="100%"
                h="60px"
              ></Box>
              <Splide
                className="w-full"
                options={{
                  type: "slide",
                  pagination: false,
                  arrows: false,
                  drag: "free",
                  perPage: 6,
                  gap: 10,
                  lazyLoad: "nearby",
                }}
              >
                {gameOptions?.map((platform) => {
                  const isActive = game == platform;
                  return (
                    <SplideSlide key={platform}>
                      <Flex
                        as={Link}
                        to={{
                          search: `?game=${platform}`,
                        }}
                        onClick={() => {
                          setOpenBetRecordDetail(true);
                        }}
                        py="5px"
                        position="relative"
                        w="100%"
                        h="150px"
                        justifyContent="center"
                        alignItems="center"
                        _after={{
                          content: "''",
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%,-50%)",
                          width: "100%",
                          height: "80px",
                          bgImage: `url('${COMMON_WEB_PATH}/theOne/berRecord/bet_record_platform${
                            isActive ? "_active" : ""
                          }.png')`,
                          bgSize: "100% 100%",
                          bgPos: "center",
                          bgRepeat: "no-repeat",
                        }}
                      >
                        <Tooltip label={platform}>
                          <AbsoluteCenter
                            top="21px"
                            bg={isActive ? "#FBF346" : "#1E181A"}
                            borderRadius={"30px"}
                            boxShadow={"inset 0px 0px 12px #9D8E89"}
                            border="1px solid #817069"
                            px="12.5px"
                            py="2.5px"
                            maxW="90px"
                            className="text-overflow"
                          >
                            <Text
                              className="text-overflow"
                              fontSize="20px"
                              fontWeight={900}
                              color={isActive ? "#2B2224" : "white"}
                            >
                              {platform}
                            </Text>
                          </AbsoluteCenter>
                        </Tooltip>
                      </Flex>
                    </SplideSlide>
                  );
                })}
              </Splide>
            </ChakraBox>
          )}
          <BetRecordDetail
            fontStyle={fontStyle}
            setOpenBetRecordDetail={setOpenModal}
            betRecordDetail={betRecords}
          />
          {/* <ChakraBox
            as={Flex}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.3 }}
            w="470px"
            minH="500px"
            bgImage={`url('${COMMON_WEB_PATH}/now888/betRecord/bet_record_background.png')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="flex-start"
            position={"relative"}
            p={6}
            pt={"50px"}
            px="50px"
          >
            <Box
              position="absolute"
              bgImage={`url('${COMMON_WEB_PATH}/now888/betRecord/bet_record_close.png')`}
              bgSize="100% 100%"
              bgPos="center"
              w="50px"
              h="50px"
              top="-10px"
              right="-10px"
              cursor="pointer"
              onClick={() => {
                setOpenModal(false);
              }}
            ></Box>

            <Box maxH="500px" overflowY="scroll" w="100%">
              {gameOptions?.map((platform) => {
                return (
                  <Flex
                    as={Link}
                    to={{
                      search: `?game=${platform}`,
                    }}
                    onClick={() => {
                      setOpenBetRecordDetail(true);
                    }}
                    py="5px"
                    position="relative"
                    w="100%"
                    justifyContent="center"
                    alignItems="center"
                    _hover={{
                      bgImage: `url('${COMMON_WEB_PATH}/now888/betRecord/bet_record_selected.png')`,
                      bgSize: "100% 100%",
                    }}
                    _after={{
                      content: "''",
                      position: "absolute",
                      bottom: "-10px",
                      left: "0",
                      width: "100%",
                      height: "10px",
                      bgImage: `url('${COMMON_WEB_PATH}/now888/betRecord/bet_record_divider.png')`,
                      bgSize: "100%100%",
                      bgPos: "center",
                    }}
                    mb="10px"
                  >
                    <Text {...fontStyle}>{platform}</Text>
                  </Flex>
                );
              })}
            </Box>
          </ChakraBox> */}
        </Flex>
      )}
    </>
  );
};

export default BetRecordButton;
